/** Human phrasing for a reminder step's offset_hours.
 *
 *  Raw hours stop being readable fast — "79 hours after invitation sent" is
 *  hard to reason about when you're spacing a cadence out, so each input shows
 *  its own value in days/hours alongside it.
 */
export function formatOffsetHours(hours) {
  const total = Number(hours);
  if (!Number.isFinite(total) || total <= 0) return "";

  const days = Math.floor(total / 24);
  const remainder = total - days * 24;
  const wholeHours = Math.floor(remainder);
  const minutes = Math.round((remainder - wholeHours) * 60);

  const parts = [];
  if (days) parts.push(`${days} day${days === 1 ? "" : "s"}`);
  if (wholeHours) parts.push(`${wholeHours} hour${wholeHours === 1 ? "" : "s"}`);
  if (minutes) parts.push(`${minutes} min`);
  if (!parts.length) return "";

  return parts.join(" ");
}

/** Short label for compact flow summaries, e.g. "1d 2h" or "3d". */
export function formatOffsetCompact(hours) {
  const total = Number(hours);
  if (!Number.isFinite(total) || total <= 0) return "—";

  const days = Math.floor(total / 24);
  const remainder = total - days * 24;
  const wholeHours = Math.round(remainder * 2) / 2;

  if (days && wholeHours) return `${days}d ${wholeHours}h`;
  if (days) return `${days}d`;
  if (wholeHours) return `${wholeHours}h`;
  return "—";
}

/** Split stored offset_hours into whole days and leftover hours for form inputs. */
export function splitOffsetHours(hours) {
  const total = Number(hours);
  if (!Number.isFinite(total) || total <= 0) return { days: "", hours: "" };

  const days = Math.floor(total / 24);
  const remainder = total - days * 24;
  const wholeHours = Math.round(remainder * 2) / 2;
  if (wholeHours >= 24) {
    return { days: String(days + 1), hours: "0" };
  }
  return {
    days: days ? String(days) : "",
    hours: wholeHours ? String(wholeHours) : "",
  };
}

/** Combine day/hour form fields back into offset_hours. Empty when both are blank. */
export function combineOffsetDaysHours(days, hours) {
  const d = Number(days) || 0;
  const h = Number(hours) || 0;
  const total = d * 24 + h;
  return total > 0 ? total : "";
}
